export const searchDropdown =  [
	{
	  title: "Return Type",
	  value: "rsaType"
	},
	{
	  title: "State",
	  value: "rsaState"
	},
	{
	  title: "Address ID ",
	  value: "rsaShipToAddressId"
	},
	{
	  title: "Inbound Class",
	  value: "rsaInboundClassification"
	}
]



// WEBPACK FOOTER //
// ./src/pages/locationMapping/filter/searchDropdown.js